module.exports = __webpack_public_path__ + "static/media/README.e1961236.md";